import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tiny0": "products-33612c4d-tiny0-WXUgJq",
  "wide8": "products-33612c4d-wide8-WXUgJq",
  "grid": "products-33612c4d-grid-WXUgJq",
  "xwide0": "products-33612c4d-xwide0-WXUgJq",
  "tiny1": "products-33612c4d-tiny1-WXUgJq",
  "default4": "products-33612c4d-default4-WXUgJq",
  "defaultOffset7": "products-33612c4d-defaultOffset7-WXUgJq",
  "confined0": "products-33612c4d-confined0-WXUgJq",
  "confined10": "products-33612c4d-confined10-WXUgJq",
  "tinyOffset6": "products-33612c4d-tinyOffset6-WXUgJq",
  "xwide12": "products-33612c4d-xwide12-WXUgJq",
  "confined5": "products-33612c4d-confined5-WXUgJq",
  "xwideOffset6": "products-33612c4d-xwideOffset6-WXUgJq",
  "confinedOffset4": "products-33612c4d-confinedOffset4-WXUgJq",
  "wideOffset8": "products-33612c4d-wideOffset8-WXUgJq",
  "default6": "products-33612c4d-default6-WXUgJq",
  "gridContainer": "products-33612c4d-gridContainer-WXUgJq",
  "confined8": "products-33612c4d-confined8-WXUgJq",
  "xwideOffset9": "products-33612c4d-xwideOffset9-WXUgJq",
  "tiny5": "products-33612c4d-tiny5-WXUgJq",
  "xwide5": "products-33612c4d-xwide5-WXUgJq",
  "xwide8": "products-33612c4d-xwide8-WXUgJq",
  "confined2": "products-33612c4d-confined2-WXUgJq",
  "confinedOffset2": "products-33612c4d-confinedOffset2-WXUgJq",
  "default2": "products-33612c4d-default2-WXUgJq",
  "wideOffset2": "products-33612c4d-wideOffset2-WXUgJq",
  "tinyOffset0": "products-33612c4d-tinyOffset0-WXUgJq",
  "wide7": "products-33612c4d-wide7-WXUgJq",
  "default8": "products-33612c4d-default8-WXUgJq",
  "default1": "products-33612c4d-default1-WXUgJq",
  "default9": "products-33612c4d-default9-WXUgJq",
  "defaultOffset5": "products-33612c4d-defaultOffset5-WXUgJq",
  "confined3": "products-33612c4d-confined3-WXUgJq",
  "default0": "products-33612c4d-default0-WXUgJq",
  "confined11": "products-33612c4d-confined11-WXUgJq",
  "xwide4": "products-33612c4d-xwide4-WXUgJq",
  "xwideOffset3": "products-33612c4d-xwideOffset3-WXUgJq",
  "tinyOffset10": "products-33612c4d-tinyOffset10-WXUgJq",
  "confined6": "products-33612c4d-confined6-WXUgJq",
  "xwide7": "products-33612c4d-xwide7-WXUgJq",
  "tinyOffset5": "products-33612c4d-tinyOffset5-WXUgJq",
  "tiny10": "products-33612c4d-tiny10-WXUgJq",
  "default10": "products-33612c4d-default10-WXUgJq",
  "confinedOffset9": "products-33612c4d-confinedOffset9-WXUgJq",
  "wide1": "products-33612c4d-wide1-WXUgJq",
  "col": "products-33612c4d-col-WXUgJq",
  "wide11": "products-33612c4d-wide11-WXUgJq",
  "confined7": "products-33612c4d-confined7-WXUgJq",
  "wideOffset7": "products-33612c4d-wideOffset7-WXUgJq",
  "wide5": "products-33612c4d-wide5-WXUgJq",
  "confinedOffset7": "products-33612c4d-confinedOffset7-WXUgJq",
  "confinedOffset1": "products-33612c4d-confinedOffset1-WXUgJq",
  "wide0": "products-33612c4d-wide0-WXUgJq",
  "wideGridContainer": "products-33612c4d-wideGridContainer-WXUgJq",
  "wideOffset6": "products-33612c4d-wideOffset6-WXUgJq",
  "tiny11": "products-33612c4d-tiny11-WXUgJq",
  "wide6": "products-33612c4d-wide6-WXUgJq",
  "xwide3": "products-33612c4d-xwide3-WXUgJq",
  "xwideOffset10": "products-33612c4d-xwideOffset10-WXUgJq",
  "defaultOffset8": "products-33612c4d-defaultOffset8-WXUgJq",
  "xwide2": "products-33612c4d-xwide2-WXUgJq",
  "confinedOffset0": "products-33612c4d-confinedOffset0-WXUgJq",
  "wide9": "products-33612c4d-wide9-WXUgJq",
  "standardGridContainer": "products-33612c4d-standardGridContainer-WXUgJq",
  "defaultOffset1": "products-33612c4d-defaultOffset1-WXUgJq",
  "default5": "products-33612c4d-default5-WXUgJq",
  "tiny8": "products-33612c4d-tiny8-WXUgJq",
  "tinyOffset4": "products-33612c4d-tinyOffset4-WXUgJq",
  "defaultOffset3": "products-33612c4d-defaultOffset3-WXUgJq",
  "tinyOffset8": "products-33612c4d-tinyOffset8-WXUgJq",
  "wideOffset10": "products-33612c4d-wideOffset10-WXUgJq",
  "defaultOffset9": "products-33612c4d-defaultOffset9-WXUgJq",
  "confined12": "products-33612c4d-confined12-WXUgJq",
  "wide10": "products-33612c4d-wide10-WXUgJq",
  "xwideOffset2": "products-33612c4d-xwideOffset2-WXUgJq",
  "confinedOffset6": "products-33612c4d-confinedOffset6-WXUgJq",
  "tinyOffset1": "products-33612c4d-tinyOffset1-WXUgJq",
  "wideOffset5": "products-33612c4d-wideOffset5-WXUgJq",
  "xwideOffset4": "products-33612c4d-xwideOffset4-WXUgJq",
  "confinedOffset3": "products-33612c4d-confinedOffset3-WXUgJq",
  "confinedOffset11": "products-33612c4d-confinedOffset11-WXUgJq",
  "xwideOffset8": "products-33612c4d-xwideOffset8-WXUgJq",
  "xwideOffset11": "products-33612c4d-xwideOffset11-WXUgJq",
  "wide3": "products-33612c4d-wide3-WXUgJq",
  "defaultOffset4": "products-33612c4d-defaultOffset4-WXUgJq",
  "tinyOffset7": "products-33612c4d-tinyOffset7-WXUgJq",
  "tinyOffset11": "products-33612c4d-tinyOffset11-WXUgJq",
  "tiny7": "products-33612c4d-tiny7-WXUgJq",
  "wideOffset11": "products-33612c4d-wideOffset11-WXUgJq",
  "wide12": "products-33612c4d-wide12-WXUgJq",
  "wideOffset0": "products-33612c4d-wideOffset0-WXUgJq",
  "defaultOffset10": "products-33612c4d-defaultOffset10-WXUgJq",
  "tiny9": "products-33612c4d-tiny9-WXUgJq",
  "tinyOffset2": "products-33612c4d-tinyOffset2-WXUgJq",
  "wide4": "products-33612c4d-wide4-WXUgJq",
  "xwideOffset1": "products-33612c4d-xwideOffset1-WXUgJq",
  "defaultOffset11": "products-33612c4d-defaultOffset11-WXUgJq",
  "confined4": "products-33612c4d-confined4-WXUgJq",
  "tiny2": "products-33612c4d-tiny2-WXUgJq",
  "xwide1": "products-33612c4d-xwide1-WXUgJq",
  "row": "products-33612c4d-row-WXUgJq",
  "xwide11": "products-33612c4d-xwide11-WXUgJq",
  "wide2": "products-33612c4d-wide2-WXUgJq",
  "tiny6": "products-33612c4d-tiny6-WXUgJq",
  "tiny4": "products-33612c4d-tiny4-WXUgJq",
  "confined1": "products-33612c4d-confined1-WXUgJq",
  "confinedOffset8": "products-33612c4d-confinedOffset8-WXUgJq",
  "xwide6": "products-33612c4d-xwide6-WXUgJq",
  "tinyOffset3": "products-33612c4d-tinyOffset3-WXUgJq",
  "armstrongGridContainer": "products-33612c4d-armstrongGridContainer-WXUgJq",
  "tinyOffset9": "products-33612c4d-tinyOffset9-WXUgJq",
  "defaultOffset2": "products-33612c4d-defaultOffset2-WXUgJq",
  "confinedOffset10": "products-33612c4d-confinedOffset10-WXUgJq",
  "defaultOffset6": "products-33612c4d-defaultOffset6-WXUgJq",
  "tiny12": "products-33612c4d-tiny12-WXUgJq",
  "confinedOffset5": "products-33612c4d-confinedOffset5-WXUgJq",
  "wideOffset1": "products-33612c4d-wideOffset1-WXUgJq",
  "xwide9": "products-33612c4d-xwide9-WXUgJq",
  "wideOffset3": "products-33612c4d-wideOffset3-WXUgJq",
  "wideOffset9": "products-33612c4d-wideOffset9-WXUgJq",
  "confined9": "products-33612c4d-confined9-WXUgJq",
  "default7": "products-33612c4d-default7-WXUgJq",
  "xwideOffset0": "products-33612c4d-xwideOffset0-WXUgJq",
  "default12": "products-33612c4d-default12-WXUgJq",
  "wideOffset4": "products-33612c4d-wideOffset4-WXUgJq",
  "default3": "products-33612c4d-default3-WXUgJq",
  "default11": "products-33612c4d-default11-WXUgJq",
  "xwideOffset5": "products-33612c4d-xwideOffset5-WXUgJq",
  "tiny3": "products-33612c4d-tiny3-WXUgJq",
  "xwide10": "products-33612c4d-xwide10-WXUgJq",
  "xwideOffset7": "products-33612c4d-xwideOffset7-WXUgJq"
};